import React, { useEffect } from "react";
import Images from "../../assets";
import Footer from "../FormFooter/FormFooter";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useGlobalState } from "../../GlobalProvider/GlobalStateProvider";
import moment from "moment/moment";
import { useSelector } from "react-redux";

export default function Forwardcontract() {
  const data = [
    {
      sno: 1,
      dueDate: "12.11.2024",
      bankDeductingDate: "12.11.2024",
      bgNumber: "0042BG000252024",
      bgUSD: "17,352.58",
      forwardUSD: "17,352.58",
      forwardCoveredFromDate: "12.11.2024 TO 12.11.2024",
    },
    // {
    //   sno: 2,
    //   dueDate: '12.11.2024',
    //   bankDeductingDate: '12.11.2024',
    //   bgNumber: '0042BG000252024',
    //   bgUSD: '17,352.58',
    //   forwardUSD: '17,352.58',
    //   forwardCoveredFromDate: '12.11.2024 TO 12.11.2024'
    // },
    // {
    //   sno: 3,
    //   dueDate: '12.11.2024',
    //   bankDeductingDate: '12.11.2024',
    //   bgNumber: '0042BG000252024',
    //   bgUSD: '17,352.58',
    //   forwardUSD: '17,352.58',
    //   forwardCoveredFromDate: '12.11.2024 TO 12.11.2024'
    // }
  ];
  const {
    setPageContent,
    page1Content,
    page2Content,
    page3Sheet1Content,
    page3Sheet2Content,
  } = useGlobalState();
  useEffect(() => {
    const capturePage3Sheet1 = async () => {
      const sheet1Element = document.getElementById("sheet1-content");
      const canvas = await html2canvas(sheet1Element);
      setPageContent("page3Sheet1Content", canvas.toDataURL("image/png"));
    };

    const capturePage3Sheet2 = async () => {
      const sheet2Element = document.getElementById("sheet2-content");
      const canvas = await html2canvas(sheet2Element);
      setPageContent("page3Sheet2Content", canvas.toDataURL("image/png"));
    };

    capturePage3Sheet1();
    capturePage3Sheet2();
  }, []);

  const handleDownloadPDF = async () => {
    if (
      document.getElementById("sheet1-content") ||
      document.getElementById("sheet2-content")
    ) {
      handleGeneratePdf();
    }
  };

  const handleGeneratePdf = async () => {
    alert("Download Start");
    // const pdf = new jsPDF("p", "mm", "a4");
    const pdf = new jsPDF("p", "mm", [210, 375]);
    const options = {
      scale: 2,
      useCORS: true,
    };

    const captureDiv = async (id) => {
      const element = document.getElementById(id);
      if (element) {
        const canvas = await html2canvas(element, options);
        return canvas.toDataURL("image/png");
      }
      return null;
    };

    const imgData1 = await captureDiv("sheet1-content");
    const imgData2 = await captureDiv("sheet2-content");
    const imgData3 = await captureDiv("sheet3-content");
    const imgData4 = await captureDiv("sheet4-content");

    const imgWidth = 210; // A4 width in mm
    const addImageToPdf = (imgData, addPage = false) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = imgData;
        img.onload = () => {
          const imgHeight = (img.height * imgWidth) / img.width;
          if (addPage) pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
          resolve();
        };
      });
    };

    if (imgData1) await addImageToPdf(imgData1);
    if (imgData2) await addImageToPdf(imgData2, true);
    if (imgData3) await addImageToPdf(imgData3, true);
    if (imgData4) await addImageToPdf(imgData4, true);

    pdf.save("Forward Contract.pdf");
  };

  const sessionData = useSelector((state) => state?.formdata);

  return (
    <>
      {/* Page -1 Start */}
      <div className="status-waiver-block" id="sheet1-content">
        <div style={{ minHeight: "1230px" }}>
          <div className="status-logo py-1 ">
            <img
              src={Images.logo}
              alt="logo"
              style={{ height: "90%", width: "30%" }}
            />
            <p className="file-name-title">
              {sessionData && sessionData?.fileName}
            </p>
          </div>
          <div className="d-flex flex-column pt-2 px-5">
            <div>
              <div className="pt-2">
                <p className="status-waiver-content">
                  LEI - 335800ZC75U7YYHZAK27.
                </p>
                <p className="status-waiver-content">
                  LEI EXPIRY DATE-12-JUL-2025
                </p>
              </div>
              <div className="d-flex pt-1 justify-content-between mt-3">
                <span className="status-waiver-content">TO</span>
                <span className="status-waiver-content">
                  DT:{moment().format("DD.MM.YYYY")}
                </span>
              </div>
              <div className="d-flex flex-column">
                <span className="status-waiver-content">The Manager, </span>
                <span className="status-waiver-content">SOUTH INDIAN BANK</span>
                <span className="status-waiver-content">
                  PURASAWALKAM HIGH ROAD,{" "}
                </span>
                <span className="status-waiver-content">KELLYS CHENNAI.</span>
              </div>
              <div className="py-4">
                <p className="status-waiver-content">Dear Sir</p>
                <p className="status-waiver-content --bold-fonts">
                  Sub: Request for forward Booking for import payments
                </p>
                <p className="status-waiver-content pt-3">
                  Request you to book forward for import payments and details as
                  given below: -
                </p>
              </div>
              <div className="mt-3">
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th className="forward_head_label">S.NO</th>
                        <th className="forward_head_label">DUE DATE</th>
                        <th className="forward_head_label">
                          BANK DEDUCTING DATE
                        </th>
                        <th className="forward_head_label">BG NUMBER</th>
                        <th className="forward_head_label">BG USD</th>
                        <th className="forward_head_label">
                          FORWARD USD BOOKED
                        </th>
                        <th className="forward_head_label">
                          FORWARD COVERED FROM DATE - TO DATE
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <tr key={index}>
                          <td className="forward_body_label">{item.sno}</td>
                          <td className="forward_body_label">
                            {/* {sessionData && sessionData?.dueDate} */}
                            {moment(sessionData && sessionData?.dueDate).format(
                              "DD/MM/YYYY"
                            )}
                          </td>
                          <td className="forward_body_label">
                            {moment(
                              sessionData && sessionData?.bankDeductionDate
                            ).format("DD/MM/YYYY")}
                          </td>
                          <td className="forward_body_label">
                            {sessionData && sessionData?.bgNumber}
                          </td>
                          <td className="forward_body_label">
                            {sessionData && sessionData?.contractAmount}
                          </td>
                          <td className="forward_body_label">
                            {sessionData && sessionData?.contractAmount}
                          </td>
                          <td className="forward_body_label">
                            {moment(
                              sessionData && sessionData?.forwardContractDate
                            ).format("DD/MM/YYYY")}{" "}
                            {/* To{" "}
                            {moment(
                              sessionData && sessionData?.bankDeductionDate
                            ).format("DD/MM/YYYY")} */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="pt-4">
                <p className="status-waiver-content ">
                  Kindly book the forward contract today itself& we authorize
                  you to debit our CC{" "}
                </p>
                <p className="status-waiver-content">
                  a/c no.0138084000000004 for forward contract charges
                  applicable.
                </p>
                <p className="status-waiver-content px-3 pt-2 mt-2">
                  Thanking you,
                </p>
                <p className="status-waiver-content px-3 pt-2 mt-2">
                  Yours faithfully,
                </p>
                <p className="status-waiver-content px-3 pt-2 mt-2">For,</p>
                <p className="status-waiver-content p-3">BEST TIMBERS</p>
                <div
                  style={{ width: "200px", height: "50px" }}
                  className="px-3"
                >
                  <img
                    src={Images?.signIcon}
                    alt="on-image"
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                <p className="status-waiver-content p-3">
                  AUTHORISED SIGNATURE
                </p>
              </div>
            </div>
            <div className="status-waiver-content"></div>
          </div>
        </div>
        <Footer />
      </div>
      {/* Page -1 End */}

      {/* Page -2 Start */}
      <div className="status-waiver-block" id="sheet2-content">
        <div style={{ minHeight: "1230px" }}>
          <div className="status-logo py-1 ">
            <img
              src={Images.logo}
              alt="logo"
              style={{ height: "90%", width: "30%" }}
            />
          </div>
          <div className="px-5 pt-5">
            <table border="1" style={{ width: "100%" }}>
              <thead>
                {/* <tr>
                  <th className="status-waiver-content border" colSpan="2" >from</th>
                
                  <th colSpan="4"> To <br />
                    The South Indian Bank Ltd <br />
                    Br. <br /></th>
                  
                </tr> */}
              </thead>

              <tbody className="sblc-table ">
                <tr className="status-waiver-content ">
                  <td className="p-1" style={{ width: "50%" }} colSpan="4">
                    From
                  </td>
                  <td className="p-1" colSpan="4">
                    <p className="mb-0"> To </p>
                    <p className="mb-0"> The South Indian Bank Ltd </p>
                    <p className="mb-0"> Br. </p>
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="8">
                    <p className="mb-0 fs-6">
                      APPLICATION FOR FORWARD CONTRACT (PURCHASE/SALE) I/We
                    </p>
                    request you to book on my/our account forward contract as
                    noted below for deliveries specified as documentary proof of
                    the forward position we are submitting herein enclosed.{" "}
                    <br />
                    1. The confirmed order indicating quantity, price, value of
                    goods to be shipped and approximate date of shipment <br />
                    2. Firm sale contract signed by the buyer/his representative
                    showing the quantity, price/value of goods, and approximate
                    date of shipment. <br />
                    3. Irrevocable Letter of Credit showing commodity, value,
                    and period of shipment.
                    <br />
                    <p className="mb-0 fs-6">
                      PARTICULARS OF SHIPMENT/CONTRACTED EXPOSURE
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Name and address of buyer/seller
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    BEST TIMBERS
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    No. & Date of order/LC{" "}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    {/* 0042BG000252024 */}
                    {sessionData && sessionData?.bgNumber
                      ? sessionData?.bgNumber
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Commodity{" "}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    {sessionData && sessionData?.commodify
                      ? sessionData?.commodify
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Quantity{" "}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    {/* 44.742 */}
                    {sessionData && sessionData?.invoiceQuantity
                      ? sessionData?.invoiceQuantity
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="2">
                    Rate
                  </td>
                  <td className="status-waiver-content p-1" colSpan="2">
                    {/* 375 */}
                    {sessionData && sessionData?.invoiceRate
                      ? sessionData?.invoiceRate
                      : null}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="2">
                    Date of Shipping{" "}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="2">
                    {/* 238036341 &{" "} */}
                    {sessionData && sessionData?.blNo
                      ? sessionData?.blNo
                      : null}{" "}
                    &{" "}
                    {moment(sessionData && sessionData?.dateOfShipping).format(
                      "DD/MM/YYYY"
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-2" colSpan="4">
                    Value
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    USD{" "}
                    {sessionData && sessionData?.bgAmtAndInterestAmt
                      ? sessionData?.bgAmtAndInterestAmt
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1 fs-5" colSpan="8">
                    FORWARD BOOKING REQUIRED
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    FCY Required to be booked
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    USD{" "}
                    {sessionData && sessionData?.contractAmount
                      ? sessionData?.contractAmount
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Amount to be booked
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    USD{" "}
                    {sessionData && sessionData?.contractAmount
                      ? sessionData?.contractAmount
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Fund/Nostro Delivery period required
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    {/* 12.11.2024 */}
                    {moment(
                      sessionData && sessionData?.forwardContractDate
                    ).format("DD/MM/YYYY")}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Exchange Rate
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    {sessionData && sessionData?.exchangeRate}
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1 fs-6" colSpan="8">
                    LEGAL ENTITY IDENTIFIER DETAILS
                  </td>
                  {/* <td className="status-waiver-content" colSpan="4">00.00</td> */}
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    LEI Code{" "}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4">
                    335800ZC75U7YYHZAK27
                  </td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="8">
                    NET WORTH DETAILS (Rs. In Crores){" "}
                  </td>
                  {/* <td className="status-waiver-content" colSpan="4">12-JUL-2024</td> */}
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="4">
                    Net Worth as on _________{" "}
                  </td>
                  <td className="status-waiver-content p-1" colSpan="4"></td>
                </tr>
                <tr>
                  <td className="status-waiver-content p-1" colSpan="8">
                    We request you to book the contract and return the
                    enclosures with your rubber stamp thereon. For your records,
                    enclosing Photostat/true copies of the contract/ LC. I/We
                    also confirm that in the event of non-submission of
                    underlying contract within 15 days from date of booking
                    forward contract, you are authorized to cancel the said
                    forward contract at our cost and exchange risk. I/We also
                    undertake to abide by the various RBI/FEMA Guidelines from
                    time to time, provisions of Indian Stamp Act and the ISDA
                    Master Agreement in prevalence. I/We, hereby declare that
                    I/We, have not entered in to any forward exchange contract
                    in respect of the above underlying with any other bank and
                    the above contract(s) is/are arising out of genuine
                    transactions. In case, if the contract is a rebooking of
                    cancelled contract booked with South Indian Bank or any
                    other bank, we confirm that the cancellation and rebooking
                    are done simultaneously and rebooking is done for the same
                    maturity period booked earlier.
                  </td>
                  {/* <td className="status-waiver-content" colSpan="4"></td> */}
                </tr>
                <tr className="">
                  <td
                    className=" status-waiver-content text-start p-1 pt-5"
                    style={{ height: "80px" }}
                    colSpan="4"
                  >
                    Date:{moment().format("DD/MM/YYYY")}
                  </td>
                  <td
                    className="status-waiver-content text-end p-1"
                    colSpan="4"
                  >
                    <div className="d-flex flex-column align-items-end">
                      <img
                        src={Images?.signIcon}
                        alt="on-image"
                        style={{ width: "100px", height: "40px" }}
                      />
                      (Authorised Signatory)
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <Footer />
      </div>
      {/* Page -2 End */}

      {/* Page -3 Start */}
      <div className="status-waiver-block  " id="sheet3-content">
        <div style={{ minHeight: "1230px" }}>
          <div className="status-logo py-1 ">
            <img
              src={Images.logo}
              alt="logo"
              style={{ height: "90%", width: "30%" }}
            />
          </div>
          <div
            className="d-flex flex-column mx-5 mt-3 p-2 justify-content-between "
            style={{ minHeight: "910px", border: "1px solid black" }}
          >
            <div>
              <p className="status-waiver-content py-2 fs-6 mb-0">
                General Terms and Conditions
              </p>
              <p className="status-waiver-content">
                1. I/We confirm that the above request for booking forward
                contract is firm and we undertake to take delivery during the
                contracted period. <br />

                2. I/We undertake to bear the cost/charges associated with early
                delivery/utilization/extension/cancellation of the contract due
                to any reason. The Bank is hereby authorized to debit our
                account on the occurrence of such event.
                <br />

                3. In the event or extension/rollover/cancellation, we undertake
                to submit to the Bank our application for cancellation of
                contract before expiry date of contracted period. In the absence
                of our instruction, Bank is authorized to cancel the contract
                after due date in keeping with extant RBI and FEDAI guidelines.
                We agree that gains if any on cancellation after due date will
                not be passed on. We also authorize the bank to debit our
                account for any losses/cost associated with such cancellation
                after due date. We also understand that any losses/cost
                associated with cancellation either before/after due date is
                chargeable to our account. <br />

                4. I/We undertake to comply with all the applicable laws and
                regulations including but not limited to the existing
                RBI/FEMA/FEDAI/ISDA Master Agreement/FATF/OFAC/AML/CFT
                regulations as may be applicable to the transaction. <br />

                5.I/We declare that the proposed booking and exposure therein
                does not involve and is not designed to contravene/evade any of
                the provisions of FEMA 1999 or act rules, notications,
                regulations, notices, directions or orders issued thereunder.
                <br />

                6. In the event of the limits available to our account, being
                exceeded with the proposed booking request, we authorize the
                Bank to cancel the contract and bring our account within limits.
                We also authorize the bank to debit our account for any
                losses/cost associated with such cancellation <br />

                7. I/We confirm that the Forward Contract outstanding in our
                account does not exceed the value of underlying exposure therein
                and no contracts are booked with the intention of
                profiteering/mere speculation. <br />

                8. I/We confirm that we have not booked any forward contracts
                against same underlying with more than one Bank and undertake
                not to book the same in future. I/We confirm that any change in
                in the underlying notional shall be immediately brought to the
                attention of the Bank. <br />
              </p>
              <p className="status-waiver-content mt-3">
                We request you to book the contract and return the enclosures
                with your rubber stamp thereon. For your records, enclosing
                Photostat/true copies of the contract/ LC. I/We, hereby declare
                that I/We, have not entered in to any forward exchange contract
                in respect of the above shipments with any other bank and the
                above contract(s) is/are arising out of genuine transactions. In
                case, if the contract is a rebooking of cancelled contract
                booked with South Indian Bank or any other bank, we confirm that
                the cancellation and rebooking are done simultaneously and
                rebooking is done for the same maturity period booked earlier.e
                further undertake that the undersigned has the authority to give
                the application, declaration, undertaking and acceptance of
                terms and conditions on behalf of the firm/company.
              </p>
            </div>

            <div className="status-waiver-content d-flex justify-content-between align-items-center ">
              <p className="mb-0">Date : {moment().format("DD/MM/YYYY")}</p>
              {/* <p className="mb-0">(Authorised Signatory)</p> */}
              <div className="d-flex flex-column align-items-end">
                <img
                  src={Images?.signIcon}
                  alt="on-image"
                  style={{ width: "100px", height: "40px" }}
                />
                (Authorised Signatory)
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {/* Page -3 End */}

      {/* Page -4 Start */}
      <div className="status-waiver-block " id="sheet4-content">
        <div style={{ minHeight: "1230px" }}>
          <div className="status-logo py-1 ">
            <img
              src={Images.logo}
              alt="logo"
              style={{ height: "90%", width: "30%" }}
            />
          </div>
          <div className=" px-5 pt-5 d-flex justify-content-center">
            <div
              className="d-flex align-items-center  pt-5 mt-5"
              style={{
                height: "100px",
                width: "100%",
                borderTop: "2px solid gray",
              }}
            >
              <p className="status-waiver-content fs-6 mb-0">
                BRANCH MANAGER’S COMMENTS AND SIGNATURE
              </p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {/* Page -4 End */}
      <div
        style={{
          textAlign: "center",
          paddingTop: "1rem",
          paddingBottom: "1rem",
          paddingLeft: "3rem",
          marginLeft: "3rem",
        }}
      >
        <button className="btn_download_file" onClick={handleDownloadPDF}>
          DOWNLOAD Forward-Contract
        </button>
      </div>
    </>
  );
}
